import axiosInstance from "../config/axiosInstance"

export const addPlan = async ({ name, price, duration, planType, benefits }) => {
  const response = await axiosInstance.post("/api/admin/create/createplan", {
    name,
    price,
    duration,
    planType,
    benefits: JSON.stringify(benefits),
  });
  
    return response; 
};

export const updatePlan = async ({
  id,
  name,
  price,
  duration,
  planType,
  benefits,
}) => {
  const response = await axiosInstance.put(`/api/admin/update/plan/${id}`, {
    name,
    price,
    duration,
    planType,
    benefits : JSON.stringify(benefits)
  });
  return response;
};